import React, { useState } from 'react';
import { useParams } from 'react-router-dom';

import Alert from '@mui/material/Alert';
import { makeStyles } from '@material-ui/core/styles';
import InputField from '../../../sharedcomponents/1elements/Fields/InputField';
import PersonAvatar from '../../../components/2compounds/PersonAvatar/PersonAvatar';
import MultiStageSwitch from '../../../sharedcomponents/2compounds/multiStageSwitch/index';

const LeftChild = ({ formikProps, editMode, activateType, isGuest }) => {
  const { partyId } = useParams();
  const classes = useStyles();
  const values = formikProps.values;
  const [showSsoUserAlert, setShowSsoUserAlert] = useState(!isGuest);

  const onAvatarUpdate = (newUrl) => {
    formikProps.setFieldValue('avatar_url', newUrl);
  };

  return (
    <div className={classes.root}>
      <div className={classes.top}>
        <div className={classes.leftPanel}>
          <div className={classes.nameWrapper}>
            <div className={classes.nameItem}>
              <InputField
                type="text"
                name="first_name"
                maxLength={150}
                required={true}
                label="First Name"
                value={values?.first_name}
                editMode={editMode}
              />
            </div>
            <div className={classes.nameItem}>
              <InputField
                type="text"
                name="last_name"
                maxLength={150}
                required={true}
                label="Last Name"
                value={values?.last_name}
                editMode={editMode}
              />
            </div>
          </div>
          <InputField
            type="phone"
            name="phone"
            label="Phone Number"
            value={values?.phone}
            values={values}
            setFieldValue={formikProps.setFieldValue}
            editMode={editMode}
          />
          <InputField
            type="email"
            name="email"
            maxLength={150}
            required={true}
            label="Email"
            value={values?.email}
            editMode={editMode}
          />
          <div style={{ display: 'none' }}>
            <InputField
              type="hidden"
              name="type"
              value={values?.type}
              editModel={false}
            />
            <InputField
              type="hidden"
              name="assertGuest"
              value={values?.assertGuest}
              editModel={false}
            />
          </div>
        </div>
        <div className={classes.rightPanel}>
          <PersonAvatar
            editMode={editMode}
            userId={partyId}
            avatar={values.avatar_url}
            onSave={onAvatarUpdate}
            name={
              formikProps.values.first_name + ' ' + formikProps.values.last_name
            }
          />
        </div>
      </div>
      <div className={classes.bottom}>
        <MultiStageSwitch
          marks={[
            { value: 0, label: 'SSO User' },
            { value: 100, label: 'Guest User' }
          ]}
          onChange={(e) => {
            const guestSelected = e === 100;
            activateType('user', guestSelected);
            formikProps.setFieldValue('type', 'user');
            formikProps.setFieldValue('assertGuest', guestSelected);
            setShowSsoUserAlert(!guestSelected);
          }}
          initialState={isGuest ? 100 : 0}
          disabled={!editMode}
        />
        {showSsoUserAlert && (
          <Alert severity="info">
            SSO User will be added into the Contracts table
          </Alert>
        )}
      </div>
    </div>
  );
};

export default LeftChild;

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    '& >*': {
      boxSizing: 'border-box'
    }
  },
  top: {
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'row'
  },
  bottom: {
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    marginTop: '25px'
  },
  leftPanel: {
    width: '60%',
    display: 'flex',
    flexDirection: 'column',
    padding: '0 10px 0 0'
  },
  rightPanel: {
    width: '40%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 0 0 10px'
  },
  nameWrapper: {
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  nameItem: {
    width: '50%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
  }
}));
